<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="left">
				<div class="leftD">
					<div class="leftD_child" v-for="(item,index) in serList" @click="todetail(item.id)">{{item.name}}</div>
				</div>
			</div>
			<div class="right">
				<div class="title">{{title}}</div>
				<div class="list flexleft">
					<div class="headerChild" v-for="(item,index) in zdList" :key="index">
						<div class="topImg">
							<img :src="$index.addurl(item.image)" alt="">
						</div>
						<div class="bottomContent">
							<div class="botTitle">{{item.title}}</div>
							<div class="botTxt">{{item.intro}}</div>
							<div class="more" @click="todetails(item)">了解详情</div>
						</div>
					</div>
				</div>
				<div class="botList">
					<div class="botchild flexleft" v-for="(items,indexs) in List" :key="indexs"
						@click="todetails(items)">
						<div class="parentLittle">
							<div class="little"></div>
						</div>
						<div class="bottitle flexbetween">
							<div class="titles">{{items.title}}</div>
							<div class="time">{{items.updatetime}}</div>
						</div>
					</div>
				</div>
				<div class="page">
					<el-pagination :hide-on-single-page="true" :current-page="currentPage" :page-size="20"
						@current-change="addPage" layout="prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default {
		components: {
			headerTop
		},
		data() {
			return {
				currentPage: 1, //分页当前页数
				img: '',
				animation: '',
				serList: [{
					name: '广场资讯',
					id: 0,
				}, {
					name: '机构动态',
					id: 1,
				}],
				current: 0,
				title: '广场资讯',
				zdList: [],
				total: 0,
				topList: [],
				List: [],
				currentId: 0,
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdatasquare();
		},
		methods: {
			addPage(e) {
				this.currentPage = e;
				if (this.currentId == 0) {
					this.getdatasquare();
				} else {
					this.getdataorganization();
				}
			},
			todetails(item) {
				let _this = this;
				if (_this.currentId == 0) {
					window.open(item.url, '_blank');
				} else {
					const {
						href
					} = _this.$router.resolve({
						name: 'squaredetail',
						query: {
							id: item.id,
							type: _this.currentId
						}
					});
					window.open(href, '_blank');
				}

			},
			todetail(id) {
				let _this = this;
				_this.currentId = id;
				this.currentPage = 1;
				if (id == 1) {
					_this.title = '机构动态';
					_this.getdataorganization();
				} else if (id == 0) {
					_this.title = '广场资讯'
					_this.getdatasquare();
				}
			},
			getdataorganization() {
				let _this = this;
				_this.$api.user.getTrendsMechanism({
					page: _this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						_this.zdList = res.data.topList;
						_this.List = res.data.list.data;
						_this.total = res.data.list.total;
						_this.img = res.data.background_img;
					}
				})
			},
			getdatasquare() {
				let _this = this;
				_this.$api.user.getTrendsSquare({
					page: _this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						_this.zdList = res.data.topList;
						_this.List = res.data.list.data;
						_this.total = res.data.list.total;
						_this.img = res.data.background_img;
					}
				})
			},
		},
	}
</script>
<style scoped>
	.content {
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
	}
</style>
<style scoped lang="scss">
	.page {
		margin: auto;
		display: flex;
		justify-content: center;
	}

	.left {
		align-self: flex-start;
		position: sticky;
		top: 100px;

		.leftD {
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 30px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 20px;

			.leftD_child {
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}

			.leftD_child:last-child {
				border: none;
			}

			.leftD_child:hover {
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}

	.swiperImg {
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;

		.lTitle {
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}

		.bTitle {
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}

		.sTitle {
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}

	.right {
		flex-grow: 1;

		.title {
			font-size: 30px;
			padding: 0 20px;
			border-left: 6px solid #1452DC;
		}

		.list {
			margin: 20px 10px 0;

			.headerChild {
				width: 30%;
				margin: 0 1.5%;
				border: 1px solid #eee;
				box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.1);

				.topImg {
					width: 100%;
					height: 200px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.bottomContent {
					padding: 20px;

					.botTitle {
						font-size: 16px;
						color: #000;
						display: -webkit-box;
						overflow: hidden;
						height: 44px;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}

					.botTxt {
						margin: 10px 0;
						font-size: 14px;
						color: #333;
						height: 44px;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}

					.more {
						padding: 4px 12px;
						border: 1px solid #000;
						text-align: center;
						width: fit-content;
						cursor: pointer;
					}
				}
			}
		}

		.botList {
			margin: 20px;

			.botchild {
				.parentLittle {
					padding: 15px;
					border: 1px solid #eee;

					.little {
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background-color: #1452DC;
					}
				}

				.bottitle {
					flex-grow: 1;
					border: 1px solid #eee;
					font-size: 14px;
					color: #333;
					line-height: 40px;
					padding: 0 10px;

					.titles {
						flex-grow: 1;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}

					.time {
						min-width: 100px;
						text-align: right;
					}
				}
			}

			.botchild:hover {
				// background-color: #1452DC;
				animation: opacitys .2s linear forwards;
				cursor: pointer;

				.parentLittle {
					border: 1px solid #1452DC;

					.little {
						background-color: #fff;
					}
				}

				.bottitle {
					color: #fff;
					border: 1px solid #1452DC;
				}
			}
		}

	}

	.center {
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 190px;
		padding: 80px 120px 60px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;

		.page {
			margin: auto;
			display: flex;
			justify-content: center;
		}

		.child {
			.img {
				width: 45%;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.txt {
				width: 45%;

			}
		}
	}
</style>


// WEBPACK FOOTER //
// square.vue?3a275474